import fineuploader from 'fineuploader';

$(function () {
  var $form = $(".application-form"),
      formDetails = {
        stepName: $form.data("stepName"),
        stepNumber: $form.data("stepNumber"),
        hasInstance: $form.data("hasInstance")
      },
      pageLeaveMessage = function() {
        if (formDetails.hasChanged) {
          return $form.data("leaveMessage");
        } else {
          return;
        }
      };

  if (formDetails.stepNumber !== 1 || !formDetails.hasInstance) {
    window.onbeforeunload = pageLeaveMessage;
  }

  // Mark the form has changed for previous button confirmation or tab-closing
  $form.find("input,select,textarea").on("change", function(e, params) {
    if (params && params.ignore) return;
    formDetails.hasChanged = true;
    if (formDetails.stepNumber !== 1 || !formDetails.hasInstance) {
      window.onbeforeunload = pageLeaveMessage;
    }
  });

  if (formDetails.stepNumber === 1) {
    var $autoFillFields = $("#id_first_name,#id_last_name,#id_email,#id_confirm_email");
    $autoFillFields.on("change", function(e, data) {
      $autoFillFields.each(function() {
        if ($(this).val() !== "") {
          $(this).trigger("blur", "ignore");
        }
      });
    });
  }

  function autoSave(e, callback) {
    // disable submission until autosave is done
    $form.find("button[type='submit']").attr("disabled", "disabled");
    $form.find("button[type='submit']").attr("title", "saving...");
    $.ajax({
      context: this,
      data: $form.serialize(),
      type: $form.attr("method"),
      url: $form.attr("action"),
    }).done(function(data) {
    // re-enable submission since autosave is done
      $form.find("button[type='submit']").removeAttr("disabled");
      $form.find("button[type='submit']").removeAttr("title");
      if (typeof(callback) == "function") {
        callback(data);
      }
      window.onbeforeunload = null;
    });
  }
  var throttledAutoSave = _.throttle(_.debounce(autoSave, 500), 5000);

  // XXX: make autosave work for inline forms
  if (formDetails.stepNumber > 1 && $(".inline-forms").length === 0) {
    if (! JSON.parse($('meta[name=disable_autosave]').attr('content'))) {
      $form.delegate("input,select,textarea", "change", throttledAutoSave);
    }
  }

  $form.submit(function(e) {
    window.onbeforeunload = null;
  });

  // Ability to clone a form in a formset
  var $inlineManagementForm = $(".inline-management-form"),
      $inlineTotalForms,
      $inlineFormTemplate = $(".school-form").last().detach();
  $inlineManagementForm.find("input").each(function() {
    var $self = $(this);
    if ($self.attr("name").indexOf("TOTAL_FORMS") >= 0) {
      $inlineTotalForms = $self;
    }
  });

  function addFormLike($inlineForm) {
    $newForm = $inlineForm.clone();
    $newForm.find("select,input,textarea").each(function() {
      // TODO: update the ID, name and the label for it
      // name=accomplishments-0-awarder_name
      // id=id_accomplishments-0-awarder_name
      var $self = $(this),
          id = $self.attr("id");
      if (!id) return;

      var idParts = id.split("-", 3),
          nameParts = $self.attr("name").split("-", 3),
          newIndex = $(".inline-form-fields").length;
      $self.attr("id", idParts[0] + "-" + newIndex + "-" + idParts[2]);
      $self.attr("name", nameParts[0] + "-" + newIndex + "-" + nameParts[2]);
    });
    $newForm.find("label").each(function() {
      var $self = $(this),
          forParts = $self.attr("for").split("-", 3),
          newIndex = $(".inline-form-fields").length;
      $self.attr("for", forParts[0] + "-" + newIndex + "-" + forParts[2]);
    });

    if ($newForm.data('interactions')) {
      initializeInteractions($newForm, $newForm.data('interactions'));
    }
    $newForm.appendPolyfillTo($(".inline-forms"));
    $newForm.find(".countable").each(function() {
      makeCountable($(this));
    });
    if ($('.fine-uploader-s3').length > 0) {
      $('.fine-uploader-s3').fineUploaderS3(getUploaderOptions()).on('complete', onUploadComplete);
    }
    $inlineTotalForms.val(parseInt($inlineTotalForms.val(), 10) + 1);
  }

  $form.find(".add-form").click(function(e) {
    e.preventDefault();
    addFormLike($inlineFormTemplate);
    if ($form.data("maxForms") < parseInt($inlineTotalForms.val(), 10)) {
      $(this).hide();
    }
  });

  $form.delegate(".application-row.category > select", "change", function(e) {
    $(this).parent().siblings('.application-row').addClass('show');
    $(this).parents('.inline-forms').next('.application-button').addClass('show');
  });

  $form.delegate(".delete-form", "click", function(e) {
    e.preventDefault();
    var $inlineForm = $(this).closest(".inline-form");

    $inlineForm.find(".delete-input").val("on").end()
      .next(".inline-form-undo").show().data("fields", $inlineForm.find(".inline-form-fields"));

    $inlineForm.find(".inline-form-fields").slideUp(function() {
      var idField = $(this).parent(".school-form").find('[name^=schools-][name$=-id]'),
          isInitialObject = !!idField.val();

      if (isInitialObject) {
        $(this).detach();
      }
      else {
        $(this).parent(".school-form").detach();
      }

      $('.inline-form-fields').each(function (index, element) {
        $(element).parent(".school-form").find("select,input,textarea").each(function() {
          var $self = $(this),
              id = $self.attr("id");
          if (!id) return;

          var idParts = id.split("-", 3),
              nameParts = $self.attr("name").split("-", 3),
              newIndex = index;
          $self.attr("id", idParts[0] + "-" + newIndex + "-" + idParts[2]);
          $self.attr("name", nameParts[0] + "-" + newIndex + "-" + nameParts[2]);
        });
        $(element).parent(".school-form").find("label").each(function() {
          var $self = $(this),
              forParts = $self.attr("for").split("-", 3),
              newIndex = index;
          $self.attr("for", forParts[0] + "-" + newIndex + "-" + forParts[2]);
        });
      });
    });

    // Do not decrement the total count if the form is an initial form
    var idField = $inlineForm.find('[name^=schools-][name$=-id]');
    if (! idField.val()) {
      $inlineTotalForms.val(parseInt($inlineTotalForms.val(), 10) - 1);
    }
    if ($form.data("maxForms") + 1 > parseInt($inlineTotalForms.val(), 10)) {
      $form.find(".add-form").show();
    }
  });

  $form.delegate(".undo-delete-form", "click", function(e) {
    e.preventDefault();
    var $inlineUndo = $(this).closest(".inline-form-undo").hide();
    $inlineUndo.data("fields").appendTo($inlineUndo.prev(".inline-form"))
      .slideDown()
      .find(".delete-input").val("");
    $inlineTotalForms.val(parseInt($inlineTotalForms.val(), 10) + 1);
    if ($form.data("maxForms") < parseInt($inlineTotalForms.val(), 10)) {
      $form.find(".add-form").hide();
    }
  });

  function getAppRow(fieldName) {
    $row = $form.find("#id_" + formDetails.stepName + "-" + fieldName).closest(".application-row");
    // XXX: use this directly instead of falling back
    if ($row.length === 0) {
      $row = $form.find("[name='" + formDetails.stepName + "-" + fieldName + "']").closest(".application-row");
    }
    return $row;
  }
  function changeInteraction($input, isInitializing) {
    var val = $input.val(),
        fieldName = $input.data("fieldName"),
        field = $form.data("interactions")[fieldName],
        isChecked = $input.is(":checked"),
        i, $select;
    if (isChecked) {
      if (field.values[val]) {
        for (i in field.subfields) {
          $row = getAppRow(field.subfields[i]);
          if (field.values[val].fields.indexOf(field.subfields[i]) >= 0) {
            $row.show();
            $form.find(".row-heading." + field.subfields[i]).show().addClass("required");
            $select = $row.find("select");
            if (field.values[val].requiredFields && field.values[val].requiredFields.indexOf(field.subfields[i]) !== -1) {
              $row.addClass('required').find("input,select,textarea").each(requireIfOurInput);
            }
          } else {
            $row.hide().removeClass('required');
            $row.find("input,select,textarea").removeAttr("required");
            $form.find(".row-heading." + field.subfields[i]).hide();
          }
        }
      }
    } else if (isInitializing) {
        for (i in field.subfields) {
          $row = getAppRow(field.subfields[i]);
          $row.hide().removeClass('required');
          $row.find("input,select,textarea").removeAttr("required");
          $form.find(".row-heading." + field.subfields[i]).hide();
        }
    }
  }
  function onInteractionChange(e) {
    changeInteraction($(this), false);
  }

  function initializeInteractions($form, interactions) {
    var field, i,
        $input;
    for (var fieldName in interactions) {
      field = interactions[fieldName];
      $input = $form.find("[name=" + formDetails.stepName + "-" + fieldName + "]");
      $input.data("fieldName", fieldName).on("change", onInteractionChange);
      if ($input.filter(":checked").length) {
        $input.filter(":checked").trigger("change");
      } else {
        changeInteraction($input.first(), true);
      }
    }
  }

  function getUploaderOptions($input) {
    var options = {
      request: {
        // required by fine uploader
        endpoint: $input.data("requestEndpoint"),
        accessKey: $input.data("accessKeyId"),
        // optional, but required by django
        customHeaders: {
          "X-CSRFToken": $.cookie("csrftoken")
        }
      },
      cors: {
        expected: true,
        sendCredentials: true  // send cookies, e.g. django authentication
      },

      template: "accomplishment-upload-template",

      // REQUIRED: Path to our local server where requests
      // can be signed.
      signature: {
        endpoint: "/application/s3/",
        customHeaders: {
          "X-CSRFToken": $.cookie("csrftoken")
        }
      },

      // OPTIONAL: An endopint for Fine Uploader to POST to
      // after the file has been successfully uploaded.
      // Server-side, we can declare this upload a failure
      // if something is wrong with the file.
      uploadSuccess: {
        endpoint: "/application/s3/success/",
        customHeaders: {
          "X-CSRFToken": $.cookie("csrftoken")
        }
      },

      // USUALLY REQUIRED: Blank file on the same domain
      // as this page, for IE9 and older support.
      iframeSupport: {
        localBlankPagePath: "/public/application-s3-success.html"
      },

      // optional feature
      chunking: {
        enabled: true
      },

      // optional feature
      resume: {
        enabled: true
      },

      // optional feature
      deleteFile: {
        enabled: true,
        method: "POST",
        endpoint: "/application/s3/delete/",
        customHeaders: {
          "X-CSRFToken": $.cookie("csrftoken")
        }
      },

      // optional feature
      validation: {
        itemLimit: 5,
        sizeLimit: $input.data("sizeLimit")
      },

      thumbnails: {
        placeholders: {
          // notAvailablePath: "/public/img/not_available-generic.png",
          // waitingPath: "/public/img/waiting-generic.png"
          notAvailablePath: "/public/media/icons/icon_file.png",
          waitingPath: "/public/media/icons/icon_file.png"
        }
      }
    };

    if ($("#accomplishment_id").val()) {
      options.session = {
        endpoint: "/application/accomplishments/attachments/",
        params: {
          accomplishment: $('#accomplishment_id').val()
        }
      };
    }

    return options;
  }

  function saveAttachmentsString(context, filesDetailsString) {
      if (!$("#accomplishment_id").val()) {
        return
      }

      $.ajax({
         context: context,
         data: {
           accomplishment: $('#accomplishment_id').val(),
           attachments: filesDetailsString
         },
         type: "POST",
         url: "/application/accomplishment/attachments/"
      }).done(function(data) {
        // pass
      });
  }
  function onUploadComplete(e, id, name, response) {
    var $fileEl = $(this).fineUploaderS3("getItemByFileId", id),
        $viewBtn = $fileEl.find(".view-btn"),
        $input, filesDetails, filesDetailsString;

    if (response.success) {
      $viewBtn.attr("href", response.url).show();
      $input = $("#" + $(this).data("target"));
      $input.val($input.val() + "\n" + response.key);
      filesDetails = $input.data("filesDetails") || {};
      filesDetails[id] = {
        name: name,
        url: response.key
      };
      filesDetailsString = JSON.stringify(filesDetails);
      $input.data("filesDetails", filesDetails).val(filesDetailsString).trigger("change");
      saveAttachmentsString(this, filesDetailsString);
    }
  }

  if ($form.data('interactions')) {
    initializeInteractions($form, $form.data('interactions'));
  }
  // Load FineUploader for all existing elements
  if ($('.fine-uploader-s3').fineUploaderS3) {
    $('.fine-uploader-s3').each(function() {
      var $textarea = $("#" + $(this).data("target"));
      $(this).fineUploaderS3(getUploaderOptions($(this))).on('complete', onUploadComplete).on('delete', function(e, id) {
        var $input = $("#" + $(this).data("target")),
            filesDetails = $input.data("filesDetails"),
            filesDetailsString;
        delete filesDetails[id];
        filesDetailsString = JSON.stringify(filesDetails);
        if (filesDetailsString === "{}") {
          filesDetailsString = "";
        }
        saveAttachmentsString(this, filesDetailsString);
        $input.data("filesDetails", filesDetails).val(filesDetailsString);
      });
      if ($textarea.val()) {
        $textarea.data("filesDetails", $.parseJSON($textarea.val()));
      }
    });
  }
});



// WEBPACK FOOTER //
// client/application/all-steps.js